<template>
  <div class="payment-confirmation">
    <Row class="detail-header">
      <span>结案到款记录</span>
      <Button
        v-if="editState" type="primary"
        class="add-btn" @click="addPaymentConfirmation"
      >添加到款记录</Button>
    </Row>
    <Row class="table-container">
      <Row class="payment">已认领/客户收款赔偿款：{{ common.formateNumber(claimData.claimOrCustIncomeAmount) }} &nbsp;&nbsp;诉讼退费金额：{{ common.formateNumber(claimData.claimOrCustIncomeOtherAmount) }} </Row>
      <!-- <Row class="payment"><span v-if="claimData.claimIncomeDate">实收认领对应收款时间：{{ claimData.claimIncomeDate }} &nbsp;&nbsp;</span> <span v-if="claimData.custIncomeDate">客户收款对应收款时间：{{ claimData.custIncomeDate }}</span></Row> -->
      <Row class="table-box">
        <Table
          :columns="columnsFormat" :data="dataList"
          :loading="tableLoading"
        >
          <template slot="attachments" slot-scope="{ row, index }">
            <p
              v-for="(item, i) in row.attachments"
              :key="i" :title="item.fileName"
              class="textover" :style="{ cursor: 'pointer',color: styles.globalMainColor,paddingBottom: '5px'}"
              @click="handleLinkView(item)"
            >{{ item.fileName }}</p>
          </template>
        </Table>
      </Row>
    </Row>

    <!-- 文件预览 -->
    <preview-file ref="perviewFile" />

    <!-- 新增到款记录 -->
    <Modal
      v-model="addCtrl"
      :title="`${btnType=='add'?'新增': '修改'}到款记录`"
      :width="450"
      :footer-hide="true"
    >
      <Form
        v-if="addCtrl" ref="formValidate"
        :model="formValidate" :rules="ruleValidate"
        :label-width="90"
      >
        <FormItem label="结案时间" prop="closeTime">
          <DatePicker
            :value="formValidate.closeTime" style="width:100%"
            type="date" placeholder="请填写结案时间"
            @on-change="getTime($event,'closeTime')"
          />
        </FormItem>
        <FormItem label="结案方式" prop="closeType">
          <Select
            v-model="formValidate.closeType" placeholder="请选择结案方式"
            clearable
            @on-change="caseTypeChange"
          >
            <Option
              v-for="item in caseCloseTypeArr" :key="item.value"
              :value="item.value"
            >{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <template v-if="formValidate.closeType === 'ZE'">
          <FormItem label="0元结案理由" prop="closeReason">
            <Input
              v-model.trim="formValidate.closeReason" type="textarea"
              :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入0元结案理由"
            />
          </FormItem>
        </template>
        <template v-else>
          <FormItem label="结案金额" :prop="formValidate.closeType == 'WI'? 'WIcloseAmount': 'closeAmount'">
            <my-input
              append-text="￥"
              :default-data="formValidate.closeAmount"
              :to-fixed="2"
              @getValue="getInputValue($event,'closeAmount')"
            />
            <span v-if="amountMessage" style="color:#ffa43b">两次结案金额不一致，请检查结案金额是否正确！</span>
          </FormItem>
          <FormItem label="付款主体" prop="paymentSubject">
            <Input v-model.trim="formValidate.paymentSubject" placeholder="请输入付款主体" />
          </FormItem>
          <FormItem label="付款时间" prop="paymentDate">
            <DatePicker
              :value="formValidate.paymentDate" style="width:100%"
              type="date" placeholder="请填写付款时间"
              @on-change="getTime($event,'paymentDate')"
            />
          </FormItem>
          <FormItem label="付款期数" prop="numberPayment">
            <Select v-model="formValidate.numberPayment" placeholder="请选择付款期数">
              <Option
                v-for="item in numberPaymentArr" :key="item.id"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
          <FormItem label="赔偿金额" prop="paymentArrivalFee">
            <my-input
              placeholder="请输入本次到款金额"
              append-text="￥"
              :default-data="formValidate.paymentArrivalFee"
              :to-fixed="2"
              @getValue="getInputValue($event,'paymentArrivalFee')"
            />
          </FormItem>
          <FormItem
            label="诉讼退费" prop="otherArrivalFee"
            :rules="[{validator:overMillion, trigger: 'blur'}]"
          >
            <my-input
              placeholder="请输入本次到款金额"
              append-text="￥"
              :default-data="formValidate.otherArrivalFee"
              :to-fixed="2"
              @getValue="getInputValue($event,'otherArrivalFee')"
            />
          </FormItem>
          <FormItem label="收款方" prop="receipt">
            <Select v-model="formValidate.receipt" placeholder="请选择收款方">
              <Option
                v-for="item in receiptArr" :key="item.id"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
          <FormItem label="收款时间" prop="receiptTime">
            <DatePicker
              :value="formValidate.receiptTime" style="width:100%"
              type="date" placeholder="请填写收款时间"
              @on-change="getTime($event,'receiptTime')"
            />
          </FormItem>
          <FormItem
            v-if="formValidate.receipt==='C'" label="收款主体"
            prop="customerBankId"
          >
            <Select
              v-model="formValidate.customerBankId" clearable
              placeholder="请选择收款主体" @on-change="changeCustomerBank"
            >
              <Option
                v-for="item in customerBankArr" :key="item.id"
                :value="item.id"
              >
                {{ item.accountOwner+'-'+ item.bank+'-'+ item.account }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input
              v-model.trim="formValidate.remark" type="textarea"
              :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"
            />
          </FormItem>
          <FormItem label="附件" prop="attachments">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{maxNum: 100}"
              @getFileList="getAttachmentList"
            />
          </FormItem>
        </template>
        <Row style="text-align:center;">
          <Button
            v-preventReClick type="primary"
            :disabled="isAddPayment"
            @click="infoComparison('formValidate')"
          >确认</Button>
          <Button style="margin-left: 8px" @click="addCtrl=false;">取消</Button>
        </Row>
      </Form>
    </Modal>
    <!-- 确认到款 -->
    <!-- 通过modal -->
    <Modal
      v-model="confirmCtrl"
      title="确认到款"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">请问是否确认这笔到款记录？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="confirmation"
        >确认</Button>
        <Button style="margin-left: 8px" @click="confirmCtrl=false;">取消</Button>
      </Row>
    </Modal>
    <!-- 删除到款 -->
    <Modal
      v-model="delCtrl"
      title="删除到款"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">请问是否确认删除这笔到款记录？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="delSubmit()"
        >确认</Button>
        <Button style="margin-left: 8px" @click="delCtrl=false;">取消</Button>
      </Row>
    </Modal>

    <!-- 到款记录提示modal -->
    <Modal
      v-model="tipCtrl"
      title="到款记录提示"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">两次填写的结案信息不一致，是否使用本次填写的结案金额、结案时间和结案方式？选择是，则会自动更新之前填写的结案金额、结案时间和结案方式，选择否，则需将本次的结案信息修改成与上次结案信息一致后再提交！</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isAddPayment"
          @click="submit(true)"
        >是</Button>
        <Button style="margin-left: 8px" @click="tipCtrl=false;">否</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {},
  props: ['caseId', 'processId', 'editState', 'casetype'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    const timeCheck = (rule, value, callback) => {
      if (new Date(value).getTime() - new Date(this.formValidate.paymentDate).getTime() < 0) {
        return callback(new Error('收款时间不能早于付款时间'))
      }
      callback()
    }
    const validateAmount = (rule, value, callback) => {
      if (this.oldCloseAmount && Number(value) != this.oldCloseAmount) {
        this.amountMessage = true
      } else {
        this.amountMessage = false
      }
      if (Number(value) <= 0) {
        return callback(new Error('结案金额需大于0'))
      }
      callback()
    }
    return {
      styles: styles,
      overMillion: overMillion,
      validateAmount: validateAmount,
      editId: '',
      id: '',
      delCtrl: false,
      tableLoading: false,
      delId: '',
      dataList: [],
      columnsA: [
        {
          title: '结案时间',
          key: 'closeTime',
          width: 90
        },
        {
          title: '付款时间',
          key: 'paymentDateStr',
          width: 90
        },
        {
          title: '付款期数',
          key: 'numberPaymentName',
          width: 90
        },
        {
          title: '结案方式',
          key: 'closeTypeName',
          width: 80
        },
        {
          title: '结案金额',
          key: 'closeAmount',
          width: 100,
          render: (h, params) => {
            return h('span', this.common.formateNumber(params.row.closeAmount))
          }
        },
        {
          title: '赔偿金额',
          key: 'paymentArrivalFee',
          width: 100,
          render: (h, params) => {
            return h('span', this.common.formateNumber(params.row.paymentArrivalFee))
          }
        },
        {
          title: '诉讼退费',
          key: 'otherArrivalFee',
          width: 100,
          render: (h, params) => {
            return h('span', this.common.formateNumber(params.row.otherArrivalFee))
          }
        },
        {
          title: '付款主体',
          key: 'paymentSubject',
          width: 120
        },
        {
          title: '收款方',
          key: 'receiptName',
          width: 80
        },
        {
          title: '收款时间',
          key: 'receiptTimeStr',
          width: 100
        },
        {
          title: '收款主体',
          key: 'receiptAccountOwner',
          width: 120
        },
        {
          title: '备注',
          key: 'remark',
          width: 120
        },
        {
          title: '附件',
          key: 'attachments',
          slot: 'attachments',
          width: 120
        },
        {
          title: '状态',
          key: 'stateName',
          width: 80,
          fixed: 'right',
          render: (h, params) => {
            let color
            const state = params.row.state
            switch (true) {
              case state == 'P':color = 'warningColor'; break
              case state == 'E':color = 'successColor'; break
            }
            return h('Tag', {
              class: 'textover',
              attrs: {
                title: params.row.stateName,
                color: styles[color]
              },
              style: {
                borderRadius: '11px'
              }
            }, params.row.stateName)
          }
        },
        {
          title: '操作',
          width: 80,
          fixed: 'right',
          render: (h, params) => {
            // let confirmBtn = h('Button',{
            //     attrs:{
            //         size:'small',
            //         type:'primary'
            //     },
            //     on:{
            //         click:()=>{
            //             this.id = params.row.id;
            //             this.confirmCtrl = true;
            //         }
            //     }
            // },'确认')
            const editBtn = h('Icon', {
              attrs: {
                title: '修改',
                size: 16,
                type: 'md-create'
              },
              on: {
                click: () => {
                  this.btnType = 'edit'
                  this.addCtrl = true
                  this.getDetail(params.row)
                }
              }
            })
            const delBtn = h('Icon', {
              attrs: {
                type: 'ios-trash',
                title: '删除',
                size: 16
              },
              style: {
                marginLeft: '5px'
              },
              on: {
                click: () => {
                  this.delCtrl = true
                  this.delId = params.row.id
                }
              }
            })
            if (params.row.state === 'E') {
              return []
            } else if (params.row.isCreator && params.row.state === 'P' && this.editState) {
              return [editBtn, delBtn]
            } else if (params.row.isCreator && params.row.state === 'P') {
              return [delBtn]
            }
            // else if(!params.row.isCreator&&params.row.state==='P'){
            //     return [confirmBtn];
            // }
          }
        }
      ],
      columnsB: [
        {
          title: '结案时间',
          key: 'closeTime'
        },
        {
          title: '结案方式',
          key: 'closeTypeName'
        },
        {
          title: '结案金额',
          key: 'closeAmount',
          render: (h, params) => {
            return h('span', this.common.formateNumber(params.row.closeAmount))
          }
        },
        {
          title: '0元结案理由',
          key: 'closeReason'
        },
        {
          title: '状态',
          key: 'stateName',
          render: (h, params) => {
            let color
            const state = params.row.state
            switch (true) {
              case state == 'P':color = 'warningColor'; break
              case state == 'E':color = 'successColor'; break
            }
            return h('Tag', {
              class: 'textover',
              attrs: {
                title: params.row.stateName,
                color: styles[color]
              },
              style: {
                borderRadius: '11px'
              }
            }, params.row.stateName)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            const editBtn = h('Icon', {
              attrs: {
                title: '修改',
                size: 16,
                type: 'md-create'
              },
              on: {
                click: () => {
                  this.btnType = 'edit'
                  this.addCtrl = true
                  this.getDetail(params.row)
                }
              }
            })
            const delBtn = h('Icon', {
              attrs: {
                type: 'ios-trash',
                title: '删除',
                size: 16
              },
              style: {
                marginLeft: '5px'
              },
              on: {
                click: () => {
                  this.delCtrl = true
                  this.delId = params.row.id
                }
              }
            })
            if (params.row.state === 'E') {
              return []
            } else if (params.row.isCreator && params.row.state === 'P' && this.editState) {
              return [editBtn, delBtn]
            } else if (params.row.isCreator && params.row.state === 'P') {
              return [delBtn]
            }
            // else if(!params.row.isCreator&&params.row.state==='P'){
            //     return [confirmBtn];
            // }
          }
        }
      ],
      addCtrl: false,
      receiptArr: [],
      numberPaymentArr: [],
      oldCloseAmount: '',
      amountMessage: false,
      customerBankArr: [], // 客户银行
      defaultList: [],
      formValidate: {
        closeTime: '',
        paymentDate: '',
        closeAmount: '',
        WIcloseAmount: '', // 为了兼容结案金额撤诉金额验证的情况添加的属性，无需提交的参数
        paymentArrivalFee: '',
        closeReason: '',
        otherArrivalFee: '',
        numberPayment: '',
        paymentSubject: '',
        receipt: '',
        receiptTime: '',
        closeType: '',
        customerBankId: '',
        receiptAccountOwner: '',
        remark: '',
        attachments: []
      },
      ruleValidate: {
        closeTime: [{ required: true, message: '结案时间不能为空', trigger: 'change' }],
        paymentDate: [{ required: true, message: '付款时间不能为空', trigger: 'change' }],
        closeAmount: [
          { required: true, message: '结案金额不能为空', trigger: 'blur' },
          { validator: overMillion, trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' }
        ],
        WIcloseAmount: [
          { validator: overMillion, trigger: 'blur' },
          { required: true, message: '结案金额不能为空', trigger: 'blur' }
        ],
        paymentArrivalFee: [
          { required: true, message: '赔偿金额不能为空', trigger: 'blur' },
          { validator: overMillion, trigger: 'blur' }
        ],
        closeType: [{ required: true, message: '结案方式不能为空', trigger: 'blur' }],
        paymentSubject: [
          { required: true, message: '付款主体不能为空', trigger: 'blur' },
          { max: 32, message: '不能超过32个字符', trigger: 'blur' }
        ],
        numberPayment: [{ required: true, message: '付款期数不能为空', trigger: 'change' }],
        closeReason: [{ required: true, message: '0元结案理由不能为空', trigger: 'change' }],
        receipt: [{ required: true, message: '收款方不能为空', trigger: 'change' }],
        receiptTime: [
          { required: true, message: '收款时间不能为空', trigger: 'change' }
        ]
      },
      isSubmit: false,
      isAddPayment: false,
      isHasHistory: false,
      confirmCtrl: false,
      tipCtrl: false,
      amountReceivable: '',
      caseCloseTypeArr: [],
      claimData: {},
      btnType: ''
    }
  },
  computed: {
    amountActuallyReceived() {
      let sum = 0
      this.dataList && this.dataList.length > 0 ? this.dataList.map(item => {
        sum += item.paymentArrivalFee
      }) : 0
      return this.common.formateNumber(sum)
    },
    columnsFormat() {
      // 是否是0元结案
      const isZeroCase = this.dataList.some(item => item.closeType === 'ZE')
      return isZeroCase ? this.columnsB : this.columnsA
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getDictionary()
    this.getAmount()
    this.getData()
  },
  mounted() {},
  updated() {},
  methods: {
    caseTypeChange(value) {
      console.log('value===', value)
      this.isAddPayment = false
      if (!['RE', 'JU', 'ME'].includes(value)) return
      const urlObj = {
        RE: '/business/case/reconcile/check/', // 检查和解审核通过信息是否存在
        JU: '/business/case/judgment/check/', // 检查判决信息是否存在
        ME: '/business/case/mediation/check/' // 检查调解审核通过信息是否存在
      }
      const tipMsg = {
        RE: '该案件缺少和解节点信息，请尽快完成和解信息填写并审核通过!', // 检查和解审核通过信息是否存在
        JU: '该案件缺少判决节点信息，请尽快完成判决信息填写并审核通过！', // 检查判决信息是否存在
        ME: '该案件缺少调解节点信息，请尽快完成调解信息填写并审核通过！' // 检查调解审核通过信息是否存在
      }
      const url = urlObj[value] + this.caseId
      // this.isAddPayment = true
      this.$get(url)
        .then(res => {
          if (res.code == 0 && res.data) {
            // this.isAddPayment = false
          } else {
            this.$Message.warning(tipMsg[value])
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
        })
    },
    // 获取应收金额
    getAmount() {
      this.$get(`/settlement/finance-claim-or-cust-income/${this.caseId}`).then(res => {
        if (res.code == 0) {
          this.claimData = res.data
        } else {
          this.claimData = {}
        }
      })
    },
    getInputValue(data, name) {
      this.formValidate[name] = data || 0
      if (name == 'closeAmount') {
        this.formValidate.WIcloseAmount = data || 0
      }
    },
    getCustomerBank() {
      // 获取客户账户信息
      const url = `/base/customer-bank/case-id/${this.caseId}/plugin`
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.customerBankArr = res.data ? res.data : []
        }
      })
    },
    changeCustomerBank(value) {
      this.formValidate.receiptAccountOwner = ''
      if (value) {
        this.formValidate.receiptAccountOwner = this.customerBankArr.find(item => item.id === value).accountOwner
      }
    },
    // 获取附件列表
    getAttachmentList (arr) {
      this.formValidate.attachments = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        if (item.id) { obj.id = item.id }
        this.formValidate.attachments.push(obj)
      })
    },
    getTime(data, name) {
      this.formValidate[name] = data
    },
    async addPaymentConfirmation() {
      this.btnType = 'add'
      this.amountMessage = false
      this.getCustomerBank()
      await this.getData()
      this.addCtrl = true
      this.isAddPayment = false
      for (const key in this.formValidate) {
        if (['closeTime', 'closeAmount'].includes(key) || (key === 'closeType' && this.isHasHistory)) {
          console.log('不重置表单')
        } else {
          this.formValidate[key] = ''
        }
      }
      this.formValidate.attachments = []
      this.defaultList = []
    },
    // 提交参数
    ajaxData() {
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      if (this.formValidate.closeType === 'ZE') {
        // 0元结案
        const tempObj = {
          closeTime: this.formValidate.closeTime,
          closeType: this.formValidate.closeType,
          closeReason: this.formValidate.closeReason
        }
        Object.assign(ajaxData, tempObj)
      } else {
        Object.assign(ajaxData, this.formValidate)
        delete ajaxData.WIcloseAmount
      }
      return ajaxData
    },
    // 到款记录-结案信息比对
    infoComparison() {
      this.$refs['formValidate'].validate((vaild) => {
        if (vaild) {
          const url = '/business/case/payment-record/close-compare'
          const ajaxData = this.ajaxData()
          if (this.editId) {
            ajaxData.id = this.editId
          }
          this.$post(url, ajaxData).then(res => {
            if (res.code === 0) {
              const bool = res.data
              if (bool) {
                this.submit()
              } else {
                this.tipCtrl = true
              }
            }
          })
        }
      })
    },
    submit(bool) {
      this.$refs['formValidate'].validate((vaild) => {
        if (vaild) {
          this.isSubmit = true
          const url = '/business/case/payment-record'
          const ajaxData = this.ajaxData()
          // 两次提交信息不一致时多传一个 useCurrentCloseInfo 参数
          if (bool) {
            ajaxData.useCurrentCloseInfo = true
          }
          if (this.btnType === 'edit') {
            ajaxData.id = this.editId
            this.$patch(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.isSubmit = false
                this.tipCtrl = false
                this.getData()
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.isSubmit = false
                this.tipCtrl = false
                this.getData()
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
    delSubmit() {
      const url = '/business/case/payment-record/' + this.delId
      this.isSubmit = true
      this.$del(url).then(res => {
        this.isSubmit = false
        if (res.code == 0) {
          this.delCtrl = false
          this.$Message.success('操作成功')
          this.getData()
        } else {
          this.$Message.error(res.message || '操作失败')
        }
      })
    },
    confirmation() {
      this.isSubmit = true
      const url = `/business/case/payment-record/${this.id}/confirm`
      this.$patch(url).then(res => {
        this.confirmCtrl = false
        this.isSubmit = false
        if (res.code === 0) {
          this.$Message.success('操作成功')
          this.getData()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 获取详情
    getData() {
      const url = '/business/case/payment-records/' + this.processId
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            if (res.code === 0) {
              this.dataList = res.data
              this.getDefaultData(this.dataList)
              this.addCtrl = false
              resolve()
            }
          })
          .finally(() => {
            reject()
          })
      })
    },
    getDefaultData(data) {
      if (!data || data.length === 0) return
      // 记录是否存在历史到款记录：用于新建到款时，是否重置结算方式字段
      this.isHasHistory = true
      const tempItem = data[0]
      this.oldCloseAmount = (data[0] && data[0].closeAmount) || ''
      this.formValidate.closeTime = tempItem.closeTime
      this.formValidate.closeType = tempItem.closeType
      this.formValidate.closeAmount = tempItem.closeAmount
    },
    getDetail(value) {
      this.getCustomerBank()
      const data = JSON.parse(JSON.stringify(value))
      this.editId = data.id
      for (const key in this.formValidate) {
        this.formValidate[key] = data[key]
      }
      this.defaultList = this.formValidate.attachments
      this.amountMessage = false
      this.oldCloseAmount = this.dataList.length > 1 ? (this.dataList[0] && this.dataList[0].closeAmount) || '' : ''
      this.formValidate.paymentDate = data.paymentDateStr
      this.formValidate.receiptTime = data.receiptTimeStr
    },
    // 打开链接
    handleLinkView(item) {
      const arr = ['image', 'sheet', 'ms-excel', 'xlsx', 'xls', 'document', 'msword', 'docx', 'doc', 'powerpoint', 'presentation', 'pdf', 'text/plain', 'txt']
      if (arr.some(value => item.mediaType.includes(value))) {
        // arr里面 是在线预览，其他都打开新窗口
        this.$refs.perviewFile.preview(item)
      } else {
        const url = item.url
        window.open(url, '_blank')
        return
      }
    },
    // 获取字典数据接口
    async getDictionary() {
      this.receiptArr = await this.common.getDictionaryItems('payee_type')
      this.numberPaymentArr = await this.common.getDictionaryItems('number_payment')
      this.receiptArr = this.receiptArr.filter(item => item.value !== 'L')
      this.caseCloseTypeArr = await this.common.getDictionaryItems('case_close_type')
      if (this.casetype === 'CL') {
        this.caseCloseTypeArr = this.caseCloseTypeArr && this.caseCloseTypeArr.filter(item => item.value !== 'NC')
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/globalStyle.scss';
@import '../caseCommon.scss';
.payment-confirmation{
    .table-container{
        border-top:1px solid $borderColor;
    }
    .payment{
        padding: 5px 0px;
        font-size: 12px;
        font-weight: 600;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/paymentConfirmation/index.vue